import { render, staticRenderFns } from "./SelectProductBlock.vue?vue&type=template&id=21e83e4a&scoped=true"
import script from "./SelectProductBlock.vue?vue&type=script&lang=js"
export * from "./SelectProductBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e83e4a",
  null
  
)

export default component.exports